import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Gate } from '../../../models/gate';
import { Screen } from '../../../models/screen';
import { Entrance } from '../../../models/entrance';
import { GateService } from 'src/app/services/gate.service';

const MODE_SYSTEM_DETAILS = 0;
const MODE_SET_BRIGHTNESS = 1;
const MODE_SET_ALARM = 2;

@Component({
  selector: 'app-gate-dialog',
  host: {
    "[style.width]": "'100%'",
    "[style.min-width]": "'700px'",
    "[style.height]": "'100%'",
  },
  templateUrl: './gate-dialog.component.html',
  styleUrls: ['./gate-dialog.component.scss']
})
export class GateDialogComponent implements OnInit {

  isUpdating: boolean = false;

  gate: Gate;
  entrance: Entrance;
  screens: Screen[] = [];
  hasScreen: boolean = false;

  dialogMode: number = MODE_SYSTEM_DETAILS;

  isDualScreenGate: boolean = false;

  // Screen 1
  dayBrightnessSliderValue: number = 0;
  nightBrightnessSliderValue: number = 0;
  autoBrightness: boolean = false;

  currentDayBrightnessValue: number = this.dayBrightnessSliderValue;
  currentNightBrightnessValue: number = this.nightBrightnessSliderValue;
  currentAutoBrightness: boolean = this.autoBrightness;

  // Screen 2
  dayBrightnessSliderValue2: number = 0;
  nightBrightnessSliderValue2: number = 0;
  autoBrightness2: boolean = false;

  currentDayBrightnessValue2: number = this.dayBrightnessSliderValue2;
  currentNightBrightnessValue2: number = this.nightBrightnessSliderValue2;
  currentAutoBrightness2: boolean = this.autoBrightness2;

  // Alarm
  alarmTransmitPower: number = 8;
  alarmReceivePower: number = 8;
  alarmPowerLevel: number = 5;
  alarmPatternChoice: number = 1;

  refresh: boolean = false;

  constructor(private _gateService: GateService,
    public dialogRef: MatDialogRef<GateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.gate = data.gate;
      this.entrance = data.entrance;
      this.dialogMode = MODE_SYSTEM_DETAILS;
      this.screens = data.screens;
      console.log(this.screens);
      this.resetAlarmSettings();
      
      this.isDualScreenGate = false;
      this.hasScreen = this.screens.length > 0;
      
      if (this.screens.length >= 1) {
        this.currentDayBrightnessValue = this.screens[0].brightnessDay;
        this.currentNightBrightnessValue = this.screens[0].brightnessNight;
        this.currentAutoBrightness = this.screens[0].autoBrightness;
      } 

      if (this.screens.length >= 2) {
        //assume just 2
        this.currentDayBrightnessValue2 = this.screens[1].brightnessDay;
        this.currentNightBrightnessValue2 = this.screens[1].brightnessNight;
        this.currentAutoBrightness2 = this.screens[1].autoBrightness;
        this.isDualScreenGate = true;
      }
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    // console.log("gate-dialog", this.gate, this.entrance);
  }

  onSystemDetailsClick(gate: Gate): void {
    this.dialogMode = MODE_SYSTEM_DETAILS;
  }

  onBrightnessModeClick(gate: Gate): void {
    this.dayBrightnessSliderValue = this.currentDayBrightnessValue;
    this.nightBrightnessSliderValue = this.currentNightBrightnessValue;
    this.autoBrightness = this.currentAutoBrightness;
    
    this.dialogMode = MODE_SET_BRIGHTNESS;
  }

  onAlarmModeClick(gate: Gate): void {
    this.dialogMode = MODE_SET_ALARM;
  }

  resetAlarmSettings(): void {
    this.alarmTransmitPower = 8;
    this.alarmReceivePower = 8;
    this.alarmPowerLevel = 5;
    this.alarmPatternChoice = 1;
  }

  onSetBrightnessClick(): void {
    this.isUpdating = true;
    this._gateService.editScreenBrightness(this.screens[0], this.dayBrightnessSliderValue, this.nightBrightnessSliderValue, this.autoBrightness)
      .subscribe(_ => { 
        this.isUpdating = false; 
        this.currentDayBrightnessValue = this.dayBrightnessSliderValue;
        this.currentNightBrightnessValue = this.nightBrightnessSliderValue;
        this.currentAutoBrightness = this.autoBrightness;
        this.refresh = true;
      }, _ => { this.isUpdating = false; });
  }

  onSetBrightnessClick2(): void {
    this.isUpdating = true;
    this._gateService.editScreenBrightness(this.screens[1], this.dayBrightnessSliderValue2, this.nightBrightnessSliderValue2, this.autoBrightness2)
      .subscribe(_ => { 
        this.isUpdating = false; 
        this.currentDayBrightnessValue2 = this.dayBrightnessSliderValue2;
        this.currentNightBrightnessValue2 = this.nightBrightnessSliderValue2;
        this.currentAutoBrightness2 = this.autoBrightness2;
        this.refresh = true;
      }, _ => { this.isUpdating = false; });
  }

  onScreenSwitchClick(): void {
    this.isDualScreenGate = !this.isDualScreenGate;
  }
}
